import { EntityInfoCard, useEntity } from '@backstage/plugin-catalog-react';

import { RadixAppTile } from '../RadixAppTile/RadixAppTile';
import { radixAppsFromAnnotation } from './radixAppsAnnotation';
import { useRadixClusters } from '../../hooks/useRadixClusters';

import styles from './RadixCard.module.css';

export const RadixCard = () => {
  const { entity } = useEntity();
  const { clusters } = useRadixClusters();
  const apps = radixAppsFromAnnotation(entity.metadata.annotations, clusters);

  if (apps.length === 0) {
    return null;
  }

  return (
    <EntityInfoCard title="Radix Apps" className={styles.card}>
      <div className={styles.grid}>
        {apps.map(app => (
          <RadixAppTile key={app.consoleUrl} app={app} />
        ))}
      </div>
    </EntityInfoCard>
  );
};
